import CRUDFactory from '@/services/CRUDFactory';

export default CRUDFactory('/payment-invoices');
